"use client";

import { cn } from "@acme/utils";
import { cva } from "class-variance-authority";
import * as React from "react";

import { Label as LabelUI } from "@/components/base-ui/label";

const labelVariants = cva("");

function Label({ className, ...props }: React.ComponentProps<typeof LabelUI>) {
  return (
    <LabelUI
      data-slot="label"
      className={cn(labelVariants(), className)}
      {...props}
    />
  );
}

export { Label };
